import { SessionData } from '../../models/session.models';
// tslint:disable: class-name

export const SESSION_ACTION_TYPES = {
  INIT: '[Session init] -initialize current session-',
  STARTED: '[Session started] - Session Start Success'
};

export class Action_Session_Init {
  readonly type = SESSION_ACTION_TYPES.INIT;
  constructor() { }
}

export class Action_Session_Started {
  readonly type = SESSION_ACTION_TYPES.STARTED;
  constructor(public payload: SessionData) { }
}



